export const DEFAULT_MINIMUM_BUDGET = 1000;
